<template>
  <div class="cited-push-templateConfigDetail">
    <templateConfigDetail :template-options="subscribeTypes" />
  </div>
</template>

<script>
import templateConfigDetail from '@/components/templateConfig/templateConfigDetail.vue'
import templateConfigMixin from '@/mixins/templateConfig'
export default {
  name: 'CitedPushTemplateConfigDetail',
  components: {
    templateConfigDetail
  },
  mixins: [templateConfigMixin],
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.cited-push-templateConfigDetail {
  padding: 20px;
}
</style>
